
































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { AddEditChannelDto, Channel, Settings, InteractionTypes, ChannelStyleTypes, AllowedPostSettings } from "@/services/channels/types";
import { getSetting, setSetting } from "@/services/autoSettings/autoSettingsService";
import { FormComponent, FormComponentModel } from "@/services/autoSettings/types";
import { getAllStyles } from "@/services/styles/stylesService";
import { ChannelStyle, Style } from "@/services/styles/types";
import {
    createChannel, getAcl,
    getAlreadyUsedPostTypes,
    getChannelById,
    updateChannel
} from "@/services/channels/channelsService";
import ChannelSettings from "@/components/channels/ChannelSettings.vue";
import { AclMember } from "@/services/security/types";
import ChannelAccess from "@/components/channels/ChannelAccess.vue";
import ChannelPosts from "@/components/channels/ChannelPosts.vue";
import CollapsePanel from "@/components/common/CollapsePanel.vue";
import DragReorderable from "@/components/common/DragReorderable.vue";
import { validateForm } from "@/services/validation/validationService";
import ChannelPreviewModal from "@/components/channels/modals/ChannelPreviewModal.vue";
import ChannelInfoModal from "@/components/channels/modals/ChannelInfoModal.vue";
import UnsavedFormModal from "@/components/common/modals/UnsavedFormModal.vue";
import HeaderActionButtons from "@/components/layouts/HeaderActionButtons.vue";
import { Route } from "vue-router";
import { FavoriteDto, FavoriteEntityType } from "@/services/favorites/types";
import { setFavorite } from "@/services/favorites/favoriteService";
import { HavePermition, PermitionEnum } from "@/components/security/Permitions";
import { bus } from "@/bus";
import { getAllChannelStyles } from "@/services/styles/channelStylesService";
import { settingsValidators } from "@/components/channels/validators";
import { getValidators } from "@/services/common/helpers";

@Component<ChannelForm>({
    beforeRouteLeave(to, from, next) {
        this.onBeforeRouteLeave(to, next);
    },
    components: {
        ChannelSettings,
        ChannelAccess,
        ChannelPosts: ChannelPosts,
        HeaderActionButtons,
        UnsavedFormModal,
        ChannelPreviewModal,
        ChannelInfoModal,
        CollapsePanel,
        DragReorderable
    }
})
export default class ChannelForm extends Vue {
    @Getter("getCurrentUser", { namespace: "authentication" }) getCurrentUser: any;
    @Prop() private channelId!: string;
    @Prop() private folderId!: string;
    componentsData = [] as FormComponentModel[];
    formState = false;
    channel = {
        name: "",
        folderId: this.folderId ? this.folderId : "",
        allowedPostTypes: [] as Array<AllowedPostSettings>,
        favorite: false
    } as Channel;

    permitionEnum = PermitionEnum;
    havePermition = HavePermition;
    interactionTypes = InteractionTypes;

    // used for comparing if form have changes
    priorChannelState = {
        folderId: this.folderId ? this.folderId : "",
        allowedPostTypes: [] as Array<AllowedPostSettings>,
        favorite: false,
        name: "",
        width: 0,
        height: 0,
        transitionTime: 0,
        transitionType: "none",
        interactionType: this.interactionTypes.none,
        returnToFirstPostTime: 60,
        defaultShowTime: 15,
        menuStyleId: null,
        durationIndicator: false,
        counterIndicator: false,
        durationIndicatorStyleID: null,
        counterIndicatorStyleID: null
    } as Channel;

    priorAclState = [] as AclMember[];
    nextRoute = "";
    routeParams = {};
    continue = false;
    fetchingActive = false;
    saveClicked = false;
    localId = this.channelId || "";
    validators = settingsValidators;

    alreadyUsedPostTypes = [] as string[];
    styles: Style[] = [];
    ChannelStyleOptions: ChannelStyle[] = [];
    acl = [] as AclMember[];
    selectedPostTypes = [] as string[];
    allowedPostTypesState = true;
    // lifecycle hooks
    created() {
        this.fetchData();
        this.initComponents();
    }

    // computed
    get settings(): Settings {
        return this.channel ? {
            height: this.channel.height,
            width: this.channel.width,
            transitionTime: this.channel.transitionTime,
            transitionType: this.channel.transitionType || "none",
            returnToFirstPostTime: this.channel.returnToFirstPostTime || 60,
            interactionType: this.channel.interactionType || this.interactionTypes.none,
            defaultShowTime: this.channel.defaultShowTime || 15,
            menuStyleId: this.channel.menuStyleId || this.defaultStyle(this.menuStyles),
            durationIndicator: this.channel.durationIndicator || false,
            counterIndicator: this.channel.counterIndicator || false,
            durationIndicatorStyleID: this.channel.durationIndicatorStyleID || this.defaultStyle(this.durationStyles),
            counterIndicatorStyleID: this.channel.counterIndicatorStyleID || this.defaultStyle(this.counterStyles)
        } : {} as Settings;
    }

    get postTypes(): string[] {
        return this.channel.allowedPostTypes.map(x => x.postType);
    }

    get componentsAutoSettingKey(): string {
        let settingsKey = "channelFormComponents";
        settingsKey += this.localId ? "-edit" : "-create";
        return settingsKey;
    }

    get counterStyles() {
        return this.ChannelStyleOptions.filter(x => x.type === ChannelStyleTypes.counter || x.type === ChannelStyleTypes.all);
    }

    get menuStyles() {
        return this.ChannelStyleOptions.filter(x => x.type === ChannelStyleTypes.menuStyle || x.type === ChannelStyleTypes.all);
    }

    get durationStyles() {
        return this.ChannelStyleOptions.filter(x => x.type === ChannelStyleTypes.duration || x.type === ChannelStyleTypes.all);
    }

    defaultStyle(styles: ChannelStyle[]) {
        const stylesFiltered = styles.filter(x => x.id); // Exclude "no style"
        if (stylesFiltered.length > 0 && !this.localId) {
            const defaultStyle = stylesFiltered.filter(x => x.name.toLowerCase().includes("default"))[0];
            if (defaultStyle) return defaultStyle.id;
            else return stylesFiltered[0].id;
        }
        return null;
    }

    // methods

    onBeforeRouteLeave(to: Route, next: any) {
        if (this.saveClicked || this.continue || this.fetchingActive) {
            next();
        } else {
            this.nextRoute = to.name ? to.name : "";
            this.routeParams = to.params;
            this.retrieveData();
            const noChanges = this.lodash.isEqual(this.priorChannelState, this.channel) && this.lodash.isEqual(this.priorAclState, this.acl);
            if (noChanges) {
                next();
            } else {
                next(false);
                (this.$refs.UnsavedFormModal as any).open();
            }
        }
    }

    onContinue(data: boolean) {
        this.continue = data;
        if (data) this.$router.push({ name: this.nextRoute, params: this.routeParams, query: { folder: this.channel.folderId } });
        this.nextRoute = "";
    }

    previewChannel(channelId: string, name: string) {
        (this.$refs.channelPreviewModal as any).open(channelId, name);
    }

    channelInfo(channelId: string) {
        (this.$refs.channelInfoModal as any).open(channelId);
    }

    toggleFavorite(channel: Channel) {
        const data = {
            entity: FavoriteEntityType.Channel,
            entityId: channel.id,
            state: !channel.favorite
        } as FavoriteDto;

        setFavorite(data).then(response => {
            channel.favorite = !channel.favorite;
        });
    }

    async save(back: boolean) {
        this.saveClicked = true;
        await this.childComponentsHandler();

        if (!this.formState) {
            this.saveClicked = false;
            return;
        }

        const channelDto =
            {
                channel: this.channel,
                acl: this.acl.map(x => ({ id: x.id, type: x.type }))
            } as AddEditChannelDto;

        if (!this.localId) {
            this.channel.folderId = this.folderId;
            createChannel(channelDto).then((id: string) => {
                if (back) {
                    this.$router.push({
                        path: `/channels?folder=${this.channel.folderId}`
                    });
                } else {
                    this.localId = id;
                    this.channel.id = id;
                    this.priorChannelState = JSON.parse(JSON.stringify(this.channel)) as Channel;
                    this.priorAclState = JSON.parse(JSON.stringify(this.acl)) as AclMember[];
                    this.saveClicked = false;
                }
            });
            return;
        }
        updateChannel(channelDto).then(() => {
            if (back) {
                this.$router.push({
                    path: `/channels?folder=${this.channel.folderId}`
                });
            }
            this.priorChannelState = JSON.parse(JSON.stringify(this.channel)) as Channel;
            this.priorAclState = JSON.parse(JSON.stringify(this.acl)) as AclMember[];
            this.saveClicked = false;
        });
    }

    back() {
        window.history.go(-1);
    }

    async initComponents() {
        let components = getSetting(this.componentsAutoSettingKey);
        if (!components) {
            await setSetting(this.componentsAutoSettingKey,
                [
                    {
                        componentName: "ChannelSettings",
                        order: 0,
                        collapseState: true
                    },
                    {
                        componentName: "ChannelAccess",
                        order: 1,
                        collapseState: true
                    },
                    {
                        componentName: "ChannelPosts",
                        order: 2,
                        collapseState: true
                    }] as FormComponent[]);
            components = getSetting(this.componentsAutoSettingKey);
        }

        this.componentsData = components.map((x: FormComponent) => ({
            componentName: x.componentName,
            order: x.order,
            collapseState: x.collapseState
        }));
    }

    async fetchData() {
        this.styles = await getAllStyles();

        this.ChannelStyleOptions = await getAllChannelStyles();
        this.ChannelStyleOptions.sort((a, b) => a.name.localeCompare(b.name, "en"));
        this.ChannelStyleOptions.unshift({ id: null, name: this.$t("channels.noStyle").toString(), type: ChannelStyleTypes.all, css: {} });
        this.priorChannelState.menuStyleId = this.defaultStyle(this.menuStyles);
        this.priorChannelState.durationIndicatorStyleID = this.defaultStyle(this.durationStyles);
        this.priorChannelState.counterIndicatorStyleID = this.defaultStyle(this.counterStyles);

        if (!this.localId) return;
        this.fetchingActive = true;
        this.channel = await getChannelById(this.localId);
        this.selectedPostTypes = this.channel.allowedPostTypes.map(x => x.postType);
        this.alreadyUsedPostTypes = await getAlreadyUsedPostTypes(this.localId);
        this.acl = await getAcl(this.localId);
        if (!this.channel.defaultShowTime) {
            this.channel.defaultShowTime = 15;
        }
        this.priorChannelState = JSON.parse(JSON.stringify(this.channel));
        this.priorAclState = JSON.parse(JSON.stringify(this.acl));
        bus.$emit("documentTitle", this.channel.name);
        this.fetchingActive = false;
    }

    // child components events
    onAccessUpdated(data: AclMember[]) {
        this.acl = data;
    }

    async updatePostTypeList() {
        this.alreadyUsedPostTypes = await getAlreadyUsedPostTypes(this.localId);
    }

    onSettingsUpdated(data: any) {
        const settingsComponentData = JSON.parse(data);
        this.channel.width = parseInt(settingsComponentData.settings.width) || 0;
        this.channel.height = parseInt(settingsComponentData.settings.height) || 0;
        this.channel.allowedPostTypes = JSON.parse(settingsComponentData.items) as AllowedPostSettings[];
        this.channel.transitionTime = parseInt(settingsComponentData.settings.transitionTime) || 0;
        this.channel.transitionType = settingsComponentData.settings.transitionType;
        this.channel.interactionType = settingsComponentData.settings.interactionType;
        this.channel.returnToFirstPostTime = settingsComponentData.settings.returnToFirstPostTime;
        this.channel.defaultShowTime = parseInt(settingsComponentData.settings.defaultShowTime);
        this.channel.menuStyleId = settingsComponentData.settings.menuStyleId;
        this.channel.durationIndicator = settingsComponentData.settings.durationIndicator;
        this.channel.counterIndicator = settingsComponentData.settings.counterIndicator;
        this.channel.durationIndicatorStyleID = settingsComponentData.settings.durationIndicatorStyleID;
        this.channel.counterIndicatorStyleID = settingsComponentData.settings.counterIndicatorStyleID;
    }

    onAllowedItemTypesUpdated(data: any) {
        this.selectedPostTypes = data;
    }

    async childComponentsHandler() {
        const validators = [] as any[];
        getValidators(this.$refs.channelSettings, validators);
        getValidators(this.$refs.channelAccess, validators);
        getValidators(this.$refs.channelPosts, validators);

        this.formState = await validateForm(validators);
        // validate allowed item types selected from ChannelSettings component
        if (!this.channel.allowedPostTypes ||
            this.channel.allowedPostTypes.length === 0) {
            this.allowedPostTypesState = false;
            this.formState = false;
        } else {
            this.allowedPostTypesState = true;
        }
    }

    retrieveData() {
        const channelSettings = this.$refs.channelSettings as any;
        if (channelSettings) {
            channelSettings.emitData();
        }
        const channelAccess = this.$refs.channelAccess as any;
        if (channelAccess) {
            channelAccess.emitData();
        }
    }

    get componentOrder(): string[] {
        return this.componentsData
            .slice()
            .sort((a, b) => a.order - b.order)
            .map((component) => component.componentName)
            .filter((name) => name !== "ChannelPosts" || this.localId);
    }

    set componentOrder(value: string[]) {
        for (let i = 0; i < this.componentsData.length; i++) {
            const x = this.componentsData[i];
            x.order = value.indexOf(x.componentName);
        }
        setSetting(this.componentsAutoSettingKey, this.componentsData);
    }

    getCollapseState(componentName: string) {
        const component = this.componentsData.find(x => x.componentName === componentName) as FormComponent;
        return component.collapseState;
    }

    setCollapseState(value: any, componentName: string) {
        const component = this.componentsData.find(x => x.componentName === componentName) as FormComponent;
        component.collapseState = value;
        setSetting(this.componentsAutoSettingKey, this.componentsData);
    }
}
